import flightClubEvents from 'analytics-event-schema/web_outputs/flight_club/schema.json'

export default flightClubEvents
